import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Nav, Footer, DisclaimerBar } from '../components/Chrome';
import { api } from '../api';
import { useI18n } from '../i18n';

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const { lang } = useI18n();
  const sessionId = sp.get('session_id');
  const [status, setStatus] = useState({ payment_status: 'pending' });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        setStatus(r.data);
        if (r.data.payment_status !== 'paid' && attempts < 40) {
          setTimeout(() => setAttempts(a => a + 1), 2000);
        }
      } catch (err) {
        // Transient network blip while Stripe confirms — keep polling silently, log for triage.
        console.warn('Payment status poll failed (will retry):', err);
        if (!cancelled && attempts < 40) {
          setTimeout(() => setAttempts(a => a + 1), 2000);
        }
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, attempts]);

  const paid = status.payment_status === 'paid';
  const stalled = !paid && attempts >= 40;

  return (
    <div>
      <Nav />
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div className="mono text-[10px] uppercase tracking-widest2 text-gold">
          {paid ? (lang === 'es' ? 'PAGO CONFIRMADO' : 'PAYMENT CONFIRMED') : (lang === 'es' ? 'VERIFICANDO PAGO' : 'CONFIRMING PAYMENT')}
        </div>
        <h1 className="serif text-5xl md:text-6xl mt-6">
          {paid
            ? (lang === 'es' ? 'Gracias. Comenzamos ahora.' : 'Thank you. We start now.')
            : (lang === 'es' ? 'Verificando con Stripe…' : 'Verifying with Stripe…')}
        </h1>
        {paid ? (
          <>
            <p className="mt-6 text-white/70 max-w-xl mx-auto">
              {lang === 'es'
                ? 'Recibirás un email de confirmación en instantes. Tu reporte se entregará dentro del SLA del producto elegido.'
                : "You'll receive a confirmation email shortly. Your report will be delivered within the SLA of the product you selected."}
            </p>
            <div className="mt-8 mono text-xs text-white/50">
              {lang === 'es' ? 'Monto' : 'Amount'}: <span className="text-gold">${status.amount || '—'}</span>
            </div>
          </>
        ) : stalled ? (
          <p className="mt-6 text-white/70 max-w-xl mx-auto mono text-sm">
            {lang === 'es'
              ? 'El estado sigue pendiente. Si el pago se procesó, recibirás el email de confirmación. Si tienes dudas, escribe a ceo@pheigroup.com.'
              : "Status still pending. If payment cleared you'll receive the confirmation email. If unsure, write to ceo@pheigroup.com."}
          </p>
        ) : (
          <p className="mt-6 text-white/70 max-w-xl mx-auto mono text-sm">
            {lang === 'es'
              ? 'Estamos confirmando con Stripe (puede tomar unos segundos)…'
              : 'Confirming with Stripe (may take a few seconds)…'}
          </p>
        )}
        <div className="mt-12">
          <Link to="/" className="mono text-[11px] uppercase tracking-widest2 border hairline px-6 py-3 hover:border-gold hover:text-gold" style={{transitionProperty: 'color, border-color'}} data-testid="success-home-link">
            {lang === 'es' ? '← Volver al inicio' : '← Back to home'}
          </Link>
        </div>
      </div>
      <DisclaimerBar />
      <Footer />
    </div>
  );
}
